import { render, staticRenderFns } from "./ResourceModal.vue?vue&type=template&id=48bede6e&scoped=true&"
import script from "./ResourceModal.vue?vue&type=script&lang=js&"
export * from "./ResourceModal.vue?vue&type=script&lang=js&"
import style0 from "./ResourceModal.vue?vue&type=style&index=0&id=48bede6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bede6e",
  null
  
)

export default component.exports